import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_APPLICATION_INIT_DATA_QUERY = gql`
  query ApplicationInit($input: GetApplicationInitInput!) {
    applicationInit(input: $input) {
      applicationDataId
      applicationId
      createdDatetime
      updatedDatetime
      businessUuid
      accountUuid
      businessEntityName
      businessDbaName
      phone
      incorporationState
      einAnswer
      ein
      businessEntityType
      businessPurpose
      businessAddressLine1
      businessAddressLine2
      businessAddressCity
      businessAddressState
      businessAddressCounty
      businessAddressZip
      businessAddressCountry
      businessContactFirstName
      businessContactMiddleName
      businessContactLastName
      businessContactPhone
      businessContactEmail
      businessContactAddressLine1
      businessContactAddressLine2
      businessContactAddressCity
      businessContactAddressState
      businessContactAddressCounty
      businessContactAddressZip
      businessContactAddressCountry
      status
      agreements
      businessWebsiteUrl
      noWebsite
      annualRevenue
      countriesOfOperation
      cashFlow
      numberOfEmployees
      cardMailingAddress
      businessIndustry
      bankAccountMembers {
        applicationBeneficialOwnerId
        applicationDataId
        createdDatetime
        updatedDatetime
        firstName
        middleName
        lastName
        title
        passport
        nationality
        dateOfBirth
        email
        phone
        addressLine1
        addressLine2
        city
        state
        country
        zip
        ownsSeventyFiveOrMore
        ownershipPercentage
        ssn
        ssnLast
      }
      operationalAddressLine1
      operationalAddressLine2
      operationalCity
      operationalState
      operationalCountry
      operationalPostalCode
      usNexus
      sourceOfFunds
      sourceOfFundsDescription
      accountPurpose
      accountPurposeDetail
      entityType
      transactionVolume
      transactionVolumeDescription
      isRegulated
      regulatorName
    }
  }
`;
